import { render } from "./DefVideo.vue?vue&type=template&id=bcafc82a&scoped=true"
import script from "./DefVideo.vue?vue&type=script&lang=js"
export * from "./DefVideo.vue?vue&type=script&lang=js"

import "./DefVideo.vue?vue&type=style&index=0&id=bcafc82a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcafc82a"]])

export default __exports__